import StickerGetter from './sticker';

module.exports = StickerGetter;
